// Sidebar badge defaults, so every badge reads 0 until the first poll answers.
export const EMPTY_COUNTS = {
  withdrawals: 0,
  disputes: 0,
  permissions: 0,
  queries: 0,
  verifications: 0,
  elite: 0,
  joinRequests: 0,
  brands: 0,
  venueBroadcasts: 0,
};

// Keeps only numeric counts from GET /admin/badge-counts; a missing or bad value reads 0.
export function parseBadgeCounts(data) {
  const out = { ...EMPTY_COUNTS };
  if (!data || typeof data !== "object") return out;
  for (const [k, v] of Object.entries(data)) {
    if (typeof v !== "number" && typeof v !== "string") continue;
    const n = typeof v === "string" && !v.trim() ? NaN : Number(v);
    if (Number.isFinite(n)) out[k] = n;
    else if (k in EMPTY_COUNTS) out[k] = 0;
  }
  return out;
}
